module.exports = __webpack_public_path__ + "static/sticky-notes-d95dd3ccd41fccb150c362793f5c7654.png";